'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
cbContentSlider.$inject = ['$window', '$timeout'];
var _module = angular.module('cb.ui-components.cbContentSlider', []);

_module.directive('cbContentSlider', cbContentSlider);

exports.default = _module;


function cbContentSlider($window, $timeout) {
    return {
        restrict: 'A',
        link: cbContentSliderLink
    };

    function cbContentSliderLink(scope, element, attr) {
        var version = 1.00;
        //trigger GA version event

        var sliderContent = element[0].querySelectorAll('.content-slider__item');
        var sliderContentElement = element[0].querySelector('.content-slider__content');
        var progress = element[0].querySelector('.content-slider__progress');
        var sliderElementWidth = element[0].querySelector('.content-slider__item').offsetWidth;
        var progressBtns;

        activate();

        function activate() {
            // Add progress button for every .content-slider__item
            for (var i = 1; i <= sliderContent.length; i++) {
                var e = $window.document.createElement('btn');
                e.className = 'content-slider__progress__btn';
                progress.appendChild(e);
            }

            // Add functionality to progress btn's that are added above
            $timeout(function () {
                progressBtns = element[0].querySelectorAll('.content-slider__progress__btn');

                // Set active button to first .content-slider__item
                setActiveProgressBtn(0);

                // For each button add a click event that selects the corresponding .content-slider__item
                angular.forEach(progressBtns, function (progressBtn, index) {
                    progressBtns[index].addEventListener('click', function () {
                        sliderContentElement.scrollLeft = (sliderContent[0].offsetWidth + 15) * index;

                        setActiveProgressBtn(index);
                    });
                });

                // On scroll set corresponding progress btn to active
                element[0].querySelector('.content-slider__content').addEventListener('scroll', function () {
                    var activeSliderElement = Math.round(sliderContentElement.scrollLeft / (sliderElementWidth + 15));

                    setActiveProgressBtn(activeSliderElement);
                });

                //Recalculate weetjeWidth on resize
                $window.addEventListener('resize', function () {
                    sliderElementWidth = element[0].querySelector('.content-slider__item').offsetWidth;
                });
            });
        }

        // Reset active progress btn and then set to selected index
        function setActiveProgressBtn(index) {
            var activeProgressBtn = element[0].querySelector('.content-slider__progress__btn--is-active');

            if (activeProgressBtn) {
                activeProgressBtn.classList.remove('content-slider__progress__btn--is-active');
            }

            progressBtns[index].classList.add('content-slider__progress__btn--is-active');
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/cb-content-slider.directive.js
// module id = 858
// module chunks = 0